module.exports = __webpack_public_path__ + "static/media/volkswagen.43a6bacc.png";